import { useState } from "react";
import VerticalRegistry from "../../../constants/verticalRegistry";
import { resetSearchFields } from "../utils/searchFields";

const getFirstEnabledSearchField = (searchConfig) =>
  Object.keys(searchConfig).find((key) => searchConfig[key] === true) ?? null;

const getSearchConfigByVertical = (vertical) =>
  VerticalRegistry.getVerticalByName(vertical)?.searchConfig ?? {};

const useHomeForm = (
  { values, handleChange, setFieldValue },
  setSelectedBranch,
) => {
  const searchConfig = getSearchConfigByVertical(values.vertical);

  const [activeCard, setActiveCard] = useState(() =>
    getFirstEnabledSearchField(searchConfig),
  );

  const handleVerticalChange = (e) => {
    const nextVertical = e.target.value;
    const nextSearchConfig = getSearchConfigByVertical(nextVertical);

    handleChange(e);
    setActiveCard(getFirstEnabledSearchField(nextSearchConfig));
    setSelectedBranch(null);
    resetSearchFields(setFieldValue);
    setFieldValue("branch_name", "");
    setFieldValue("branch_id", "");
  };

  const handleTabChange = (nextActiveCard) => {
    if (!searchConfig[nextActiveCard]) return;

    setActiveCard(nextActiveCard);
    resetSearchFields(setFieldValue);
  };

  return { searchConfig, activeCard, handleVerticalChange, handleTabChange };
};

export default useHomeForm;
